import { Button } from '@tackle-io/platform-ui';
import { ComponentProps, FC } from 'react';
import { Drawer } from 'vendor/material';
import FormDrawer from '../../components/FormDrawer';
import TempSolutionsSelector from './TempSolutionSelector';
import { ReferralFormProvider } from '../../ReferralFormContext';
import {
  SolutionsFromApiToFormValuesTransform,
  type SolutionsFromApiType,
  type SolutionTransformedFormValues,
} from '../SolutionsToSelectedSolutionsTransform';

interface AddSolutionsFormProps {
  onAddSolutions: (solutions: SolutionTransformedFormValues) => void;
  onClose: () => void;
  selectedIds?: SolutionsFromApiType[number]['solutionId'][];
}

export const AddSolutionsForm = ({
  onAddSolutions,
  onClose,
  selectedIds,
}: AddSolutionsFormProps) => {
  const handleAddSolutions = (solutions: SolutionsFromApiType) => {
    onAddSolutions(SolutionsFromApiToFormValuesTransform.parse(solutions));
  };

  const footerActions = (
    <>
      <Button appearance="primary" variant="outlined" onClick={onClose}>
        Cancel
      </Button>

      <Button
        disabled
        appearance="primary"
        variant="contained"
        onClick={() => alert('review solutions')}
      >
        Review solutions
      </Button>
    </>
  );
  return (
    <ReferralFormProvider>
      <FormDrawer
        footerActions={footerActions}
        title="Add Solution"
        onClose={onClose}
      >
        {/** temp component to be able to select a real solution
         *  replace with actual solution selector ui
         */}
        <TempSolutionsSelector
          selectedIds={selectedIds}
          onAddSolutions={handleAddSolutions}
          onClose={onClose}
        />
      </FormDrawer>
    </ReferralFormProvider>
  );
};

/** AddSolutionsForm wrapped in a Drawer */
export const AddSolutionsFormDrawer: FC<
  ComponentProps<typeof Drawer> & AddSolutionsFormProps
> = ({ open, onClose, onAddSolutions, selectedIds, ...props }) => {
  return (
    <Drawer
      data-testid="add-solutions-drawer"
      anchor="right"
      variant="temporary"
      open={open}
      onClose={onClose}
      {...props}
      children={
        <AddSolutionsForm
          onAddSolutions={onAddSolutions}
          onClose={onClose}
          selectedIds={selectedIds}
        />
      }
    />
  );
};
